import React from 'react';
import PropTypes from 'prop-types';

const FacetContent = React.memo(({
  checked,
  disabled,
  facetTypeKey,
  groupIndex,
  id,
  name,
  onChange,
  stat,
  campsiteType,
}) => (
  <li className={`Facets_facet${stat === 0 ? ' disabled' : ''}`}>
    <input
      checked={checked}
      disabled={disabled}
      type="checkbox"
      onChange={onChange}
      value={id}
      id={`Input_${facetTypeKey}_${groupIndex}_${id}`}
      className="Form_checkbox Form_checkbox-facets"
      data-facet-type-key={facetTypeKey}
    />
    <label className="Facets_facetLabel Form_checkboxLabel Form_checkboxLabel-small Form_checkboxLabel-facets" htmlFor={`Input_${facetTypeKey}_${groupIndex}_${id}`}>
      {!!campsiteType &&
        <span className={`Facets_campsiteTypeCircle CampsiteType CampsiteType-medium CampsiteType-${campsiteType}`}></span>
      }
      <span className="Form_checkboxLabelInner">
        {name}
        {typeof stat === 'number' &&
          <span className="Facets_facetStat"> <strong>({stat})</strong></span>
        }
      </span>
    </label>
  </li>
));

FacetContent.propTypes = {
  campsiteType: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  facetTypeKey: PropTypes.string,
  groupIndex: PropTypes.number,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  stat: PropTypes.number,
};

FacetContent.defaultProps = {
  disabled: false,
  groupIndex: 0,
};

export default FacetContent;
